import { Text } from '~/components/typography';
import { ValidatingInput, InputComponentProps } from '~/components/validating-input';

export const BillingAddressCheckbox = (props: InputComponentProps) => {
  const validate = () => {
    return true;
  };
  return (
    <ValidatingInput
      type="checkbox"
      label=""
      name="billingAddressCheckbox"
      validate={validate}
      {...props}
    >
      <Text textStyle="paragraph400" color="secondary">
        Mailing address is the same as utility address
      </Text>
    </ValidatingInput>
  );
};
